import { type Component, Show } from 'solid-js';

type Props = {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  testId?: string;
  describedBy?: string;
  class?: string;
};

/**
 * The single visual and accessibility contract for binary choices in ChorePop.
 * A button avoids native checkbox styling differences across WebView engines,
 * while role="switch" and aria-checked expose the on/off state correctly.
 */
export const ToggleSwitch: Component<Props> = (props) => (
  <button
    type="button"
    class={`toggle-switch-row${props.class ? ` ${props.class}` : ''}`}
    role="switch"
    aria-checked={props.checked}
    aria-describedby={props.describedBy}
    disabled={props.disabled}
    onClick={() => props.onChange(!props.checked)}
    data-testid={props.testId}
  >
    <span class="toggle-switch-copy">
      <strong>{props.label}</strong>
      <Show when={props.description}>{(description) => <small>{description()}</small>}</Show>
    </span>
    <span class="toggle-switch-track" classList={{ 'is-on': props.checked }} aria-hidden="true">
      <i />
    </span>
  </button>
);
